import { get, post } from "../AxiosConfig";

const getSpecialDaysConfig = () => {
  return get("/AtmAdmin/GetSpecialDaysConfig");
};

const updateSpecialDaysConfig = (payload) => {
  return post("/AtmAdmin/UpdateSpecialDaysConfig", payload);
};

const AdminService = {
  getSpecialDaysConfig,
  updateSpecialDaysConfig,
};

export default AdminService;